// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import WarrantyDatePicker from '../../../../shared/components/warranty-date-picker';
import {buildDate} from '../../../../shared/services/build-date';
import {buildMoment} from '../../../../shared/services/build-moment';
import {getFieldClassName} from '../../../shared/services/claim-shared-helper';
import {translate} from '../../../../shared/services/translation-service';

function handleDateChange(className, date) {

    const dateToSend = date ? date.valueOf() : null;

    this.onDateChange(dateToSend);

    const querySelectorClass = className.split(' ')[0];

    document.querySelector(`.${querySelectorClass} div input`).focus();

}

const LabeledDateInput = ({className, errorMessage, highlightClass, label, isValid, isEditable, vsrMessage, ...props}) =>

    <LabeledFormInput
        className={getFieldClassName(className, isValid, highlightClass)}
        label={label}
    >
        <EditableField
            isEditable={isEditable}
            value={buildDate(props.date)}
        >
            <WarrantyDatePicker
                {...props}
                onBlur={event => props.onBlur(event)}
                onChange={handleDateChange.bind(props, className)}
                selected={buildMoment(props.date)}
            />
        </EditableField>
        {
            isValid ?
                null :
                <span className='error-message'>
                    <FormattedMessage id={errorMessage}/>
                </span>
        }
        {
            vsrMessage && <span className='vsr-message'>{`${vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
        }
    </LabeledFormInput>;

LabeledDateInput.displayName = 'LabeledDateInput';
LabeledDateInput.propTypes = {
    className: PropTypes.string.isRequired,
    date: PropTypes.number,
    errorMessage: PropTypes.string,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onDateChange: PropTypes.func.isRequired,
    vsrMessage: PropTypes.string
};
LabeledDateInput.defaultProps = {
    onBlur: () => ({})
};

export default LabeledDateInput;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-date-input.js